import { render, staticRenderFns } from "./upRightT.vue?vue&type=template&id=18ed788b&scoped=true&"
import script from "./upRightT.vue?vue&type=script&lang=js&"
export * from "./upRightT.vue?vue&type=script&lang=js&"
import style0 from "./upRightT.vue?vue&type=style&index=0&id=18ed788b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ed788b",
  null
  
)

export default component.exports